var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("input", {
      directives: [
        {
          name: "model",
          rawName: "v-model",
          value: _vm.checkboxState,
          expression: "checkboxState",
        },
      ],
      staticClass: "checkbox",
      attrs: {
        id: _vm.checkboxId,
        name: _vm.checkboxName,
        type: "checkbox",
        disabled: _vm.disabled,
        autocomplete: "off",
      },
      domProps: {
        checked: Array.isArray(_vm.checkboxState)
          ? _vm._i(_vm.checkboxState, null) > -1
          : _vm.checkboxState,
      },
      on: {
        change: function ($event) {
          var $$a = _vm.checkboxState,
            $$el = $event.target,
            $$c = $$el.checked ? true : false
          if (Array.isArray($$a)) {
            var $$v = null,
              $$i = _vm._i($$a, $$v)
            if ($$el.checked) {
              $$i < 0 && (_vm.checkboxState = $$a.concat([$$v]))
            } else {
              $$i > -1 &&
                (_vm.checkboxState = $$a
                  .slice(0, $$i)
                  .concat($$a.slice($$i + 1)))
            }
          } else {
            _vm.checkboxState = $$c
          }
        },
      },
    }),
    _vm._v(" "),
    _c(
      "label",
      {
        staticClass: "checkLabel",
        class: { isFormShiryo: _vm.isFormShiryo },
        attrs: { for: _vm.checkboxId },
      },
      [_vm._t("default")],
      2
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }